<!-- 车位管控界面 -->
<template>
  <div class="control-box">
    <div class="bwgk-box">
      <p style="font-size: 16px; padding: 30px 0 0 20px; font-weight: bold;">{{ name }}</p>
      <div class="bw-detail-box">
        <div class="bw-detail-item-box">
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="margin-right: 10px;width: 10px;height: 10px;border-radius: 100%;background: #407AEE;"></p>
            <p>总泊位</p>
          </div>
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="font-weight: bold; font-size: 22px; margin-right: 10px">
              {{ totalNum }}
            </p>
            <p style="font-weight: bold">个</p>
          </div>
        </div>
        <div style="width: 1px; height: 8rem; background: #4b5566"></div>
        <div class="bw-detail-item-box">
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="margin-right: 10px;width: 10px;height: 10px;border-radius: 100%;background: #008000;"></p>
            <p>剩余泊位</p>
          </div>
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="font-weight: bold; font-size: 22px; margin-right: 10px">
              {{ remainNum }}
            </p>
            <p style="font-weight: bold">个</p>
          </div>
        </div>
        <div style="width: 1px; height: 8rem; background: #4b5566"></div>
        <div class="bw-detail-item-box">
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="margin-right: 10px;width: 10px;height: 10px;border-radius: 100%;background: #FF0000;"></p>
            <p>已用泊位</p>
          </div>
          <div style="height: 0; flex: 1; display: flex; align-items: center">
            <p style="font-weight: bold; font-size: 22px; margin-right: 10px">
              {{ totalNum - remainNum }}
            </p>
            <p style="font-weight: bold">个</p>
          </div>
        </div>
      </div>
      <div class="bw-rate-box">
        <p style="width: 94%; margin: 30px auto; position: relative">
          剩余泊位率
          <span style="position: absolute;right: 20px;font-weight: bold;font-size: 18px;">
            {{ remainRate }}
          </span>
          <span style="position: absolute; right: 5px">%</span>
        </p>
        <div id="bwRateChart" style="width: 94%;height: 8rem;display: flex;justify-content: center;
            align-items: center;margin: -50px auto 10px auto;"></div>
      </div>
    </div>
    <div>
      <CarRecord></CarRecord>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import { api } from "../api/index";
import CarRecord from "../components/CarRecord.vue";
export default {
  components: {
    CarRecord
  },
  data() {
    return {
      name: "今日泊位概况",
      bwRateChart: null,
      remainNum: 0,
      remainRate: 0,
      totalNum: 0,
    };
  },
  mounted() {
    this.initCarParkInfo();
    // this.initChartData();

    window.onresize = () => {
      this.bwRateChart.resize();
    };
  },
  beforeDestroy() {
    window.onresize = null;
  },
  methods: {
    // 获取车场信息
    initCarParkInfo() {
      this.$fetch(api.control.control, {}).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        let resObj = response.returnObj;
        this.remainNum = resObj.idleLot; // 余位数
        if (resObj.idleLotPercent.search("%") != -1) {
          this.remainRate = resObj.idleLotPercent.split("%")[0]; // 余位百分比
        } else {
          this.remainRate = 0; // 余位百分比
        }

        this.totalNum = resObj.totalLot; // 总车位数

        this.initChartData();
      });
    },
    // 初始化图形数据
    initChartData() {
      this.bwRateChart = echarts.init(document.getElementById("bwRateChart"));
      let optionChart = {
        color: ["#008000", "#FF0000"],
        grid: { x: 40, y: 60, x2: 40, y2: 20, containLabel: true, },
        // 提示框组件
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          textStyle: {
            color: "#cdd3ee",
          },
          formatter: "{b} 剩余泊位率 <br />{a0}: {c0}<br />{a1}: {c1}<br />",
        },
        xAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#cdd3ee",
              },
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              fontSize: 16,
              color: "#cdd3ee",
              formatter: "{value}",
            },
            data: [""],
          },
        ],
        series: [
          {
            type: "bar",
            name: "剩余泊位",
            stack: "总量",
            barMaxWidth: 40,
            label: {
              show: true,
              position: "inside",
            },
            itemStyle: {
              barBorderRadius: [40, 0, 0, 40],
            },
            data: [this.remainNum],
          },

          {
            type: "bar",
            name: "已用泊位",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: true,
              position: "inside",
            },
            itemStyle: {
              barBorderRadius: [0, 40, 40, 0],
            },
            data: [this.totalNum - this.remainNum], // 系列中的数据内容数组
          },
        ],
      };

      this.bwRateChart.setOption(optionChart);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.control-box {
  width: 100%;
  height: 100%;
  display: flex;
  // justify-content: center;
  flex-direction: column;
  @include set_theme_color(background-color, left-menu-bg-color);

  .bwgk-box {
    // margin-top: 20px;
    width: 100%;
    height: 400px;
    // background: #202842;
    // @include set_theme_color(background-color, left-menu-bg-color);
    // border-radius: 15px;
    display: flex;
    flex-direction: column;

    .bw-detail-box {
      width: 94%;
      height: 0;
      flex: 1;
      display: flex;
      border-bottom: 1px solid #4b5566;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .bw-detail-item-box {
        width: 0;
        height: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        // border-right: 1px solid #4b5566;
        justify-content: center;
        align-items: center;
      }
    }

    .bw-rate-box {
      width: 100%;
      height: 0;
      flex: 1;
    }
  }
}
</style>
